export enum BUSINESS_PERSONAL_TYPE {
  BUSINESS = 'Business',
  PERSONAL = 'Personal',
}
